module.exports = __webpack_public_path__ + "assets/scotch-and-soda-logo.60534384.svg";